import * as React from "react";
import { forwardRef } from "react";
const SvgRiSubtractLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "currentColor", viewBox: "0 0 24 24", width: 24, height: 24, xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 11h14v2H5z" }));
const ForwardRef = forwardRef(SvgRiSubtractLine);
export default ForwardRef;
